export class UnrecoverableError extends Error {
  constructor(message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "UnrecoverableError";
  }
}

export class WorkspaceNotFoundError extends UnrecoverableError {
  constructor(workspaceId: string, options?: ErrorOptions) {
    super(`Workspace "${workspaceId}" not found`, options);
    this.name = "WorkspaceNotFoundError";
    this.message = `Workspace "${workspaceId}" not found`;
  }
}

export class InvalidWorkspaceConfigError extends UnrecoverableError {
  constructor(workspaceId: string, options?: ErrorOptions) {
    super(`Workspace "${workspaceId}" has an invalid config`, options);
    this.name = "InvalidWorkspaceConfigError";
  }
}
